<template>
  <sui-page>
    <sui-page-header :pageId="this.$options.name" />
    <sui-page-contents>
      <sui-page-tab-box-type
        ref="tab"
        :tabItems="tabItems"
        :defaultTabIndex="defaultTabIndex"
        :setCurrentTabComponent="setCurrentTabComponent"
        @change-tab-idx="onChangeTabIdx"
      >
        <container :is="currentTabComponent"/>
      </sui-page-tab-box-type>
    </sui-page-contents>
  </sui-page>
</template>

<script>
const PGE_CMA_00006 = utils.getPageComponentById("PGE_CMA_00006");
const PGE_CMA_00013 = utils.getPageComponentById("PGE_CMA_00013");

export default {
  name: 'PGE_CMA_00012',
  components: {
    PGE_CMA_00006,
    PGE_CMA_00013,
  },
  data() {
    return {
      defaultTabIndex: 0,
      tabItems: [
        {
          tabTitle: this.$t('MSG_TXT_AUTH_APPL_PRCO'),
          component: "PGE_CMA_00006",
        },
        {
          tabTitle: this.$t('MSG_TXT_AUTH_PSS_PRCO'),
          component: "PGE_CMA_00013",
        },
      ],
      currentTabComponent: null,
      tabIndex: 0,
    };
  },
  computed: {
  },
  watch: {
  },
  datasets: [{
    id: 'dataset0',
    type: 'local',
    data: 'localdata0',
    datafields: [{
    }],
  }],
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    setCurrentTabComponent(component) {
      this.currentTabComponent = component;
    },    
    onChangeTabIdx(idx) {
      this.currentTabComponent = this.tabItems[idx].tabComponent;
    },    
  },
};
</script>

<style scoped>
</style>
